import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AccountRelink from '../../../components/account/detail-card/account-relink'
// Actions
import { accountRelink } from '../../../store/actions'

const mapStateToProps = state => {
  return {
    account: state.crm.getAccountByIdResponse,
    posting: state.crm.accountRelinkRetrieving,
    response: state.crm.accountRelinkResponse,
    error: state.crm.accountRelinkError
  }
}

const mapDispatch = dispatch => {
  return {
    accountRelink: bindActionCreators(accountRelink, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatch
)(AccountRelink)
